import React, { FC } from 'react'
import { styled, utilities } from '@creditas/stylitas'

interface StyledProps {
  clicked?: boolean
}

const CallButtonStyled = styled.button<StyledProps>`
  ${utilities.reset.button()}
  outline: none;
  border-radius: 50%;
  border: 1px solid #eeeeee;
  cursor: pointer;
  display: block;
  height: 48px;
  width: 48px;
  transition: 0.3s;

  &:hover {
    background-color: #eeeeee;
    border: 1px solid #dddddd;
  }

  ${({ clicked }): string =>
    clicked
      ? `
      background-color: #eeeeee;
      border: 1px solid #dddddd;
      animation-delay: 0.2s;
      animation-duration: 1.2s;
      animation-name: buttonexpand;
      animation-iteration-count: infinite;
      animation-timing-function: linear;

      svg {
        animation-delay: 0.2s;
        animation-duration: 1.2s;
        animation-name: iconmove;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
      }

      @keyframes iconmove {

        40%, 60% {
          margin-left: 4px;
        }

        20%, 80% {
          margin-left: 2px;
        }

        30%, 50%, 70% {
          margin-left: -4px;
        }

        10%, 90% {
          margin-left: -1px;
        }

      }

      @keyframes buttonexpand {
        50% {
          margin-left: -5px;
          padding: 5px;
          width: 58px;
          height: 58px;
        }
      }
    `
      : ''}

  box-shadow: 0px 8px 40px 0px rgba(170, 187, 187, 0.25);
`

interface Props {
  clicked: boolean
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void
  testid: string
}

const CallButton: FC<Props> = ({ children, clicked, onClick, testid }) => (
  <CallButtonStyled onClick={onClick} clicked={clicked} data-testid={testid}>
    {children}
  </CallButtonStyled>
)

export { CallButton }
